import {
  Grid,
  makeStyles,
  Drawer,
} from '@material-ui/core';
import React, { useState } from 'react';
import useCnaeContext from '../../contexts/CnaeContext';
import CnaeDetails from '../organisms/CnaeDetails';
import NotFound from '../molecules/NotFound';
import CnaeOptions from '../organisms/CnaeOptions';
import PropTypes from 'prop-types';

const useStyles = makeStyles((theme) => ({

  desktop: {
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  },
  mobile: {
    [theme.breakpoints.down('sm')]: {
      display: 'block'
    }
  },
}));

export default function WrapperInfoCnae({ noFilter }) {
  const classes = useStyles();
  const { cnaes, currentCnae } = useCnaeContext();
  const [openDrawer, setOpenDrawer] = useState(false);

  return (
    <Grid container direction="row" spacing={2}>
    {cnaes?.length > 0
      ? (
        <>
          <Grid item md={4} sm={12} style={{ width: '100%' }}>
            <CnaeOptions setOpenDrawer={setOpenDrawer} noFilter={noFilter} />
          </Grid>
            <Grid item md={8} autoCorrect className={classes.desktop}>
              <CnaeDetails currentCnae={currentCnae}/>
            </Grid>
          <Grid item className={classes.mobile}>
            <Drawer open={openDrawer} onClose={() => setOpenDrawer(false)}>
              <CnaeDetails closeDrawer={setOpenDrawer} currentCnae={currentCnae} />
            </Drawer>
          </Grid>
        </>
        )
      : (
        <NotFound />
        )}
    </Grid>
  );
}

WrapperInfoCnae.propTypes = {
  noFilter: PropTypes.bool
};

WrapperInfoCnae.defaultProps = {
  noFilter: false
};
